const DEFAULT_LIMIT = 25;
const DEFAULT_SKIP = 0;

export { getOptions, getAnalysisContext, getAnalysisContextFromLocation };

function getOptions({ state, limit, skip, sortBy, sortDirection, filter, reset }) {
    let res = {
        limit: limit != null ? limit : state.limit,
        skip: skip != null ? skip : state.skip,
        sortBy: sortBy || state.sortBy,
        sortDirection: sortDirection || state.sortDirection,
        filter: filter || state.filter
    };

    if (res.sortBy && res.sortDirection) {
        res.sort = `${res.sortBy} ${res.sortDirection}`;
    }

    res.shouldReset = !!(reset || state.sortBy !== res.sortBy || state.sortDirection !== res.sortDirection || state.filter !== res.filter);

    if (res.shouldReset) {
        res.limit = DEFAULT_LIMIT;
        res.skip = DEFAULT_SKIP;
    } else {
        res.limit = limit != null ? limit : state.limit;
        res.skip = skip != null ? skip : state.skip;
    }

    return res;
}

function getAnalysisContext(route, state, activeItem) {
    let where = {};
    let newRoute = route;

    let item = state && state.analysis && state.analysis.activeItem ? state.analysis.activeItem : activeItem || { isBox: true };

    if (route && item && item.isBox) {
        newRoute = `box${route}`;
    }

    if (location.pathname.match(/analyze/i)) {
        where = { scannedOn: { gt: item.filterOn } };
    }

    return {
        boxId: item.id,
        route: newRoute,
        where
    };
}

function getAnalysisContextFromLocation(baseRoute, search) {
    return new Promise((resolve) => {
        // Wait until location has been updated to pull new search params
        setTimeout(() => {
            let route = baseRoute;
            if (!search) {
                search = window.location.search;
            }

            let queryParams = new URLSearchParams(search);
            const item = { id: '', isBox: true };

            if (queryParams.has('scanId')) {
                item.isBox = false;
                item.id = queryParams.get('scanId');
            } else if (queryParams.has('boxId')) {
                item.isBox = true;
                item.id = queryParams.get('boxId');
            }

            if (baseRoute) {
                if (item && item.isBox) route = `box${baseRoute}`;
                else if (item && !item.isBox) route = `scan${baseRoute}`;
            }

            resolve({
                route,
                [item.isBox ? 'boxId' : 'scanId']: item.id
            });
        });
    });
}
